// Bare /liff/reports entry — registered LIFF endpoint URL for report.
// Lists every recent report the LIFF session can read; tap one to drill in.

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useLiff } from "../../../liff/index.js";
import { fetchReportsList, type ReportsListData } from "../../../liff/api.js";
import { MobileShell, Card, CardHeader, MobileSpinner, EmptyMobile, PrimaryButton } from "../../../liff/components/Mobile.js";
import { buildDashboardUrl } from "@nexus/shared/links";

export function ReportPickerPage(): React.ReactElement {
  const { session } = useLiff();
  const nav = useNavigate();
  const [data, setData] = useState<ReportsListData | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!session) return;
    fetchReportsList(session.tenant_id, session.session_token, "daily")
      .then(setData)
      .catch((e: unknown) => setError((e as Error).message));
  }, [session]);

  if (error) return (
    <MobileShell title="無法載入日報列表"><Card><p className="text-sm text-danger">{error}</p></Card></MobileShell>
  );
  if (!data) return <MobileSpinner />;
  return (
    <MobileShell title="日報" subtitle="點選任一案場日報以檢視">
      <Card>
        <CardHeader title="今日日報" hint={`${data.reports.length} 筆`} />
        {data.reports.length === 0 ? (
          <EmptyMobile title="尚未產生日報" />
        ) : (
          <ul className="divide-y divide-border-subtle -my-2">
            {data.reports.map((r) => (
              <li key={r.report_id}>
                <button
                  onClick={() => nav(`/liff/reports/${encodeURIComponent(r.report_id)}`)}
                  className="w-full text-left py-3 flex items-center justify-between gap-2"
                >
                  <div className="min-w-0">
                    <p className="text-sm font-medium truncate">{r.title}</p>
                    <p className="text-[11px] text-text-muted">{r.scope_label} · {r.date_local} · {r.generated_at_local}</p>
                  </div>
                  <span className="text-text-muted text-xs">→</span>
                </button>
              </li>
            ))}
          </ul>
        )}
      </Card>
      <PrimaryButton href={buildDashboardUrl("/dashboard/reports")}>在 Dashboard 開啟報表中心</PrimaryButton>
    </MobileShell>
  );
}
